import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import foto1 from "../images/Spa/SPA-2.jpg"
import Titolo from "../commons/Titolo";
import TabellaSpa from "../components/spa/TabellaSpa";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import CaroselloSpa from "../components/spa/CaroselloSpa";
import CardMultitessere from "../components/CardMultitessere";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import SpaAccordionPrezzi from "../components/spa/SpaAccordionPrezzi";


function Spa() {
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto1} title={"SPA"}/>
            <SpaceL/>
            <div style={{padding: "1em"}}>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <h3 >Reparto termale </h3>
                        <h4>Un ambiente dedicato al recupero e al benessere fisico</h4>
                        <br/>
                        <p>
                            Comprende una vasca termica con idromassaggio, sauna, bagno turco, <br/>lettini relax e una vasca fredda <br/> <br/>
                        </p>

                    </blockquote>
                </figure>
            <SpaceL />
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <table className="table  m-auto" style={{width: "20em"}}>
                    <colgroup>
                        <col style={{ width: "60%"}} />
                        <col  />

                    </colgroup>

                    <tbody>
                    <tr>
                        <th className="data-cell">Dal Lunedì al Venerdì</th>
                        <td className="data-cell">10-22</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Sabato</th>
                        <td className="data-cell">9-19</td>
                    </tr>
                    <tr>
                        <th className="data-cell">Domenica</th>
                        <td className="data-cell">9-13</td>
                    </tr>
                    </tbody>
                </table>
                {/*
                <p className="text-center" style={{marginTop: "2em", padding: "1em 2em 1em 2em"}}>
                    <strong>Trimestre</strong> 204 € + iscrizione: 10 €<br/>
                    <strong>Semestre</strong> 374 € + iscrizione: 20 €<br/>
                    <strong>Anno</strong> 555 € + iscrizione: 30 €
                </p>
                */}
            </div>
                <Space />

                <SpaAccordionPrezzi />

            <Space />
            <CaroselloSpa />

            <Space />
            <div className="d-flex flex-column text-center align-items-center justify-content-center">
                <TitoloSezioni title={"Multitessere"} />
                <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                <CardMultitessere />
            </div>
            <Space />
            </div>
        </div>
    )
}


export default Spa
